(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partners-agents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ORDER = ["Partner", "Agent"];
    var TITLE_MAP = { "Partner": "Partners", "Agent": "Agents" };

    function init(rootEl) {
      var url = rootEl.getAttribute("data-csv");
      if (!url) {
        rootEl.innerHTML = '<p class="partners-error">Sheet URL not set. Open this section in the customizer and paste your published CSV URL.</p>';
        return;
      }
      fetch(url, { cache: "no-store" })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
        .then(function (text) {
          var entries = rowsToObjects(parseCSV(text));
          render(rootEl, entries);
          bindFilters(rootEl.closest('[data-partners-section]'));
        })
        .catch(function (err) {
          console.error("[partners] Failed to load sheet:", err);
          rootEl.innerHTML = '<p class="partners-error">Could not load partner data. Please try again later.</p>';
        });
    }

    function parseCSV(text) {
      var rows = [], row = [], field = "", inQuotes = false;
      for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (inQuotes) {
          if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
          else if (c === '"') { inQuotes = false; }
          else { field += c; }
        } else {
          if (c === '"') { inQuotes = true; }
          else if (c === ",") { row.push(field); field = ""; }
          else if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; }
          else if (c === "\r") {}
          else { field += c; }
        }
      }
      if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
      return rows;
    }

    function rowsToObjects(rows) {
      if (!rows.length) return [];
      var headers = rows[0].map(function (h) { return h.trim(); });
      return rows.slice(1)
        .filter(function (r) { return r.some(function (v) { return v && v.trim().length; }); })
        .map(function (r) { var o = {}; headers.forEach(function (h, i) { o[h] = (r[i] || "").trim(); }); return o; });
    }

    function escapeHtml(s) {
      return String(s || "").replace(/[&<>"']/g, function (c) {
        return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
      });
    }

    function buildWebsiteHref(raw) {
      if (!raw) return "";
      var s = String(raw).trim();
      if (!s || s === "-") return "";
      if (/^https?:\/\//i.test(s)) return s;
      if (/^www\./i.test(s) || /^[a-z0-9-]+(\.[a-z0-9-]+)+/i.test(s)) return "https://" + s;
      return "";
    }

    function cardHtml(m) {
      var region  = m["Country/Region"] || m.Region || "";
      var company = m.Company || "";
      var role    = m.Role || "";
      var contact = m.Contact || "";

      var roleLine = "";
      if (role && contact) roleLine = role + " | " + contact;
      else roleLine = role || contact;

      var details = "";
      if (m.Phone) {
        details += '<div><a href="tel:' + escapeHtml(m.Phone.replace(/\s+/g, "")) + '">' + escapeHtml(m.Phone) + '</a></div>';
      }
      if (m.Email) {
        details += '<div><a href="mailto:' + escapeHtml(m.Email) + '">' + escapeHtml(m.Email) + '</a></div>';
      }
      if (m.Website) {
        var raw = String(m.Website).trim();
        if (raw && raw !== "-") {
          var href = buildWebsiteHref(raw);
          if (href) {
            details += '<div><a href="' + escapeHtml(href) + '" target="_blank" rel="noopener">' + escapeHtml(raw) + '</a></div>';
          } else {
            details += '<div>' + escapeHtml(raw) + '</div>';
          }
        }
      }

      return '<article class="partner-card" data-category="' + escapeHtml(m.Type || "") + '">' +
               (region  ? '<p class="partner-card__region">' + escapeHtml(region)  + '</p>' : "") +
               (company ? '<h3 class="partner-card__name">'  + escapeHtml(company) + '</h3>' : "") +
               (roleLine ? '<p class="partner-card__title">' + escapeHtml(roleLine) + '</p>' : "") +
               (details  ? '<div class="partner-card__contact">' + details + '</div>' : "") +
             '</article>';
    }

    function render(rootEl, entries) {
      var groups = {};
      entries.forEach(function (m) { var c = m.Type || "Other"; (groups[c] = groups[c] || []).push(m); });
      Object.keys(groups).forEach(function (c) {
        groups[c].sort(function (a, b) {
          var sa = parseInt(a.SortOrder, 10), sb = parseInt(b.SortOrder, 10);
          if (isNaN(sa)) sa = 9999; if (isNaN(sb)) sb = 9999;
          if (sa !== sb) return sa - sb;
          var ra = (a["Country/Region"] || a.Region || "");
          var rb = (b["Country/Region"] || b.Region || "");
          if (ra !== rb) return ra.localeCompare(rb);
          return (a.Company || "").localeCompare(b.Company || "");
        });
      });
      var cats = ORDER.filter(function (c) { return groups[c]; })
        .concat(Object.keys(groups).filter(function (c) { return ORDER.indexOf(c) === -1; }).sort());
      var html = cats.map(function (c) {
        var label = TITLE_MAP[c] || c;
        return '<section class="partners-section" data-category="' + escapeHtml(c) + '">' +
                 '<h2 class="partners-section__title">' + escapeHtml(label) + '</h2>' +
                 '<div class="partners-grid">' + groups[c].map(cardHtml).join("") + '</div>' +
               '</section>';
      }).join("");
      rootEl.innerHTML = html || '<p class="partners-error">No partners found in the sheet.</p>';
    }

    function bindFilters(scope) {
      if (!scope) return;
      var btns = scope.querySelectorAll(".partners-filters__btn");
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          btns.forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          var f = btn.getAttribute("data-filter");
          scope.querySelectorAll(".partners-section").forEach(function (sec) {
            var matches = (f === "all") || (sec.getAttribute("data-category") === f);
            sec.classList.toggle("is-hidden", !matches);
          });
        });
      });
    }

    function bootAll() {
      document.querySelectorAll('[data-partners-root]').forEach(init);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }
    document.addEventListener("shopify:section:load", function (e) {
      var r = e.target.querySelector('[data-partners-root]'); if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ORDER = ["Management", "Sales", "Marketing & E-Commerce", "Accounting"];

    function init(rootEl) {
      var url = rootEl.getAttribute("data-csv");
      if (!url) {
        rootEl.innerHTML = '<p class="team-error">Sheet URL not set. Open this section in the customizer and paste your published CSV URL.</p>';
        return;
      }
      fetch(url, { cache: "no-store" })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
        .then(function (text) {
          var members = rowsToObjects(parseCSV(text));
          render(rootEl, members);
          bindFilters(rootEl.closest('[data-team-section]'));
        })
        .catch(function (err) {
          console.error("[team] Failed to load sheet:", err);
          rootEl.innerHTML = '<p class="team-error">Could not load team data. Please try again later.</p>';
        });
    }

    function parseCSV(text) {
      var rows = [], row = [], field = "", inQuotes = false;
      for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (inQuotes) {
          if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
          else if (c === '"') { inQuotes = false; }
          else { field += c; }
        } else {
          if (c === '"') { inQuotes = true; }
          else if (c === ",") { row.push(field); field = ""; }
          else if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; }
          else if (c === "\r") {}
          else { field += c; }
        }
      }
      if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
      return rows;
    }

    function rowsToObjects(rows) {
      if (!rows.length) return [];
      var headers = rows[0].map(function (h) { return h.trim(); });
      return rows.slice(1)
        .filter(function (r) { return r.some(function (v) { return v && v.trim().length; }); })
        .map(function (r) { var o = {}; headers.forEach(function (h, i) { o[h] = (r[i] || "").trim(); }); return o; });
    }

    function escapeHtml(s) {
      return String(s || "").replace(/[&<>"']/g, function (c) {
        return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
      });
    }
    function safeUrl(u) {
      if (!u) return ""; var s = String(u).trim();
      if (/^https?:\/\//i.test(s) || s.indexOf("//") === 0) return s; return "";
    }

    function cardHtml(m) {
      var img = safeUrl(m.ImageUrl);
      var photo = img
        ? '<div class="team-card__photo"><img src="' + escapeHtml(img) + '" alt="' + escapeHtml(m.Name) + '" loading="lazy"></div>'
        : '<div class="team-card__photo team-card__photo--placeholder" aria-hidden="true"></div>';
      var contact = "";
      if (m.Phone) contact += '<div><a href="tel:' + escapeHtml(m.Phone.replace(/\s+/g, "")) + '">' + escapeHtml(m.Phone) + '</a></div>';
      if (m.Email) contact += '<div><a href="mailto:' + escapeHtml(m.Email) + '">' + escapeHtml(m.Email) + '</a></div>';
      return '<article class="team-card" data-category="' + escapeHtml(m.Category || "") + '">' +
               photo +
               '<h3 class="team-card__name">' + escapeHtml(m.Name) + '</h3>' +
               (m.Title ? '<p class="team-card__title">' + escapeHtml(m.Title) + '</p>' : "") +
               (contact ? '<div class="team-card__contact">' + contact + '</div>' : "") +
             '</article>';
    }

    function render(rootEl, members) {
      var groups = {};
      members.forEach(function (m) { var c = m.Category || "Other"; (groups[c] = groups[c] || []).push(m); });
      Object.keys(groups).forEach(function (c) {
        groups[c].sort(function (a, b) {
          var sa = parseInt(a.SortOrder, 10), sb = parseInt(b.SortOrder, 10);
          if (isNaN(sa)) sa = 9999; if (isNaN(sb)) sb = 9999;
          if (sa !== sb) return sa - sb; return (a.Name || "").localeCompare(b.Name || "");
        });
      });
      var cats = ORDER.filter(function (c) { return groups[c]; })
        .concat(Object.keys(groups).filter(function (c) { return ORDER.indexOf(c) === -1; }).sort());
      var html = cats.map(function (c) {
        return '<section class="team-section" data-category="' + escapeHtml(c) + '">' +
                 '<h2 class="team-section__title">' + escapeHtml(c) + '</h2>' +
                 '<div class="team-grid">' + groups[c].map(cardHtml).join("") + '</div>' +
               '</section>';
      }).join("");
      rootEl.innerHTML = html || '<p class="team-error">No team members found in the sheet.</p>';
    }

    function bindFilters(scope) {
      if (!scope) return;
      var btns = scope.querySelectorAll(".team-filters__btn");
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          btns.forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          var f = btn.getAttribute("data-filter");
          scope.querySelectorAll(".team-section").forEach(function (sec) {
            var matches = (f === "all") || (sec.getAttribute("data-category") === f);
            sec.classList.toggle("is-hidden", !matches);
          });
        });
      });
    }

    function bootAll() {
      document.querySelectorAll('[data-team-root]').forEach(init);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }
    document.addEventListener("shopify:section:load", function (e) {
      var r = e.target.querySelector('[data-team-root]'); if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
